module.exports = __webpack_public_path__ + "static/media/alarm-outline.2bfce678.svg";